import React, { useRef, useEffect } from 'react';
import { View, Text, Animated } from 'react-native';
import { useLoggedInUserPointsForRestaurant } from '../../hooks/useLoggedInUserPointsForRestaurant';
import { getCurrentTierIndex, getNextMembershipTier } from '../../utils/tierChecker';
import { fontFamily } from '../../constants/fonts';
import { colors } from '../../constants/theme';

function ProgressBarComponent({ selectedRestaurant }) {
    const userPoints = useLoggedInUserPointsForRestaurant(selectedRestaurant);

    const currentTierIndex = getCurrentTierIndex(userPoints, selectedRestaurant);
    const nextTier = getNextMembershipTier(userPoints, selectedRestaurant); 

    const animatedValue = useRef(new Animated.Value(0)).current;

    useEffect(() => {
        Animated.timing(animatedValue, {
            toValue: currentTierIndex + 1,
            duration: 500,
            useNativeDriver: false,
        }).start();
    }, [currentTierIndex]);

    
    // Calculate progress based on user points
    const pointsRequirement = nextTier ? nextTier.checkinRequirement : 0;
    const currentPoints = userPoints || 0;
    const calculatedProgressWidth = nextTier 
        ? Math.min((currentPoints / pointsRequirement) * 100, 100) 
        : 100;

    return (
        <View style={{ flexDirection: 'column' }}>
            <View style={{ height: 28, borderRadius: 16, overflow: 'hidden', borderWidth: 1, borderColor: colors.gray300, backgroundColor: colors.gray200 }}>
                <Animated.View style={{ backgroundColor: colors.yellow900, height: '100%', borderTopRightRadius: 9999, borderBottomRightRadius: 9999, width: `${calculatedProgressWidth}%` }} />
            </View>
            <Text style={{ fontSize: 16, fontFamily: fontFamily.abhaya, marginTop: 8, textAlign: 'right', color: colors.black }}>
                {nextTier ? (
                    <>
                        {`${Math.max(pointsRequirement - currentPoints, 0)} more points until `}
                        <Text style={{ fontFamily: fontFamily.abhayaBold }}>{nextTier.tier}</Text>
                        {` Status`}
                    </>
                ) : (
                    `You are already at the highest tier!`
                )}
            </Text>
        </View>
    );
}

export default ProgressBarComponent;
